import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabBarNavButton } from 'src/navigation/components/TabBarNavButton';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const renderUserTabRoutes = ({ translate }) => {
    return (React.createElement(RootTab.Group, null,
        React.createElement(RootTab.Screen, { name: "User_Home", options: {
                tabBarLabel: translate('Profile'),
                tabBarIcon: props => React.createElement(FeatherIcon, { name: "user", ...props }),
                tabBarButton: createTabBarNavButton({ screen: 'User_Home', params: {} }),
            }, component: Home })));
};
